import { palette } from './palette';

export const homeStyle = {
    /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      minHeight: `unset !important`,

      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },
  '& .checkout_stripe_payment': {
    '& .promo-spinner': {
      backgroundColor: 'unset',
    },
  },

  '.headerHighlight': {
    color: palette.text.header
  },

  '.bitedentalcenter-container': {
    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section, .faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
      {
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center',
        background: palette.background.header,
        '& .hero-header-title, & .hero-header-subtitle': {
          color: palette.text.highlight,
        },
        '& .hero-header-title': {
          fontWeight: 400
        }
      },
    '@media(max-width: 900px)': {
      '& .header-wrapper': {
        paddingBottom: '10px',
      },
    },

    '& .checkout-outer-container, .plan-selection-container': {
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      background: palette.text.highlight,

      '& .home-hero-title': {
        maxWidth: 500,
        fontWeight: 400,
      },
      '& .home-hero-subtitle': {
        maxWidth: 480
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '550px',
        width: '100%',

        '@media(min-width: 900px)': {
          '& .home-hero-title': {
            fontSize: '64px',
          }
        },
      },
      '& .login-button': {
        backgroundColor: palette.secondary.main,
        color: palette.primary.main,
        borderColor: palette.secondary.main,
      },
      '& .hero-section-alternate': {
        height: 'auto !important',
        paddingBottom: 0,

        '@media(min-width: 900px)': {
          paddingTop: 120,
        },

        '& .section-alternate__content': {
          paddingBottom: 0,

          '@media(min-width: 900px)': {
            padding: '0px',
          },

          '& .section-header': {
            '@media(min-width: 900px)': {
              minHeight: 550,
            },
          },
        },
        '& .hero-title': {
          fontSize: 42,
          fontWeight: 400,
          lineHeight: '55px',

          '@media(min-width: 600px)': {
            fontSize: 48,
            lineHeight: '60px',
          },

          '@media(min-width: 900px)': {
            fontSize: 64,
            lineHeight: '80px',
            letterSpacing: '-0.04em',
            maxWidth: 600,
          },
        },
        '& .hero-subtitle': {
          fontWeight: 400,
          fontSize: 16,
          lineHeight: '30px',
          maxWidth: 600,
          '@media(min-width: 900px)': {
            fontSize: 20,
          }
        },
        '& .MuiButton-label': {
          fontSize: 15,
          letterSpacing: '-0.03em',
        },
      },
      '& .hero-background': {
        objectFit: 'cover',
      },
      '& .image-wrapper': {
        paddingBottom: 0,
        marginBottom: -5,

        '& .image': {
          '@media(min-width: 900px)': {
            height: 688,
            width: 'auto',
          },
        },
      },
      '@media(min-width: 900px)': {
        '& .section-header__title-wrapper': {
          paddingTop: 200
        }
      }
    },

    /* Benefits - Styles */
    '& #definition-section': {
      '& .benefits-wrapper': {
        padding: '0 0',

        '& .image': {
          borderRadius: 32,
        },
      },
      '& .definition-service-title': {
        fontFamily: 'ITC Avant Garde Gothic Pro Md',
        fontWeight: 400,
        fontSize: 24,
      },
      '@media(min-width: 900px)': {
        paddingLeft: 80
      },
      '@media(max-width: 900px)': {
        '& .section-header__title': {
          fontSize: 38,
          fontWeight: 400,
        },
        '& .definition-service-description': {
          color: palette.text.light,
          paddingBottom: 24,
        }
      },
      '& .definition-service-wrapper': {
        flexDirection: 'column',
        alignItems: 'flex-start !important',
        justifyContent: 'space-around',
      },
      '& .definition-desc-wrapper': {
        borderColor: palette.divider,
      }
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      background: palette.background.main,
      '& .subscription-bg': {
        background: palette.background.main,
      },
      '& .section-header__title, .subscription-tabs-label, .summary-text, .summary-subtext': {
        color: palette.text.highlight,
      },
      '& .section-header__subtitle-wrapper': {
        display: 'flex',
        justifyContent: 'center',
        '& .section-header__subtitle': {
          color: palette.text.highlight,
          maxWidth: '680px',
        },
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          border: 'none',
          '&:hover': {
            border: `1px solid ${palette.primary.main}`,
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.disabled,
          },
          '& .price-value': {
            color: palette.text.secondary,
            fontWeight: 'bold',
          },
          '& .customGetStarted': {
            backgroundColor: palette.primary.main,
            color: palette.secondary.main,
            borderColor: palette.secondary.main,
            '&:hover': {
              backgroundColor: palette.secondary.main,
              color: palette.primary.main,
            }
          }
        },
        '& .savings-summary-link': {
          textDecoration: 'underline',
          color: palette.primary.main,
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,

      '& .howitworks-title': {
        marginBottom: 0,
      },
      '& .section-header__subtitle-wrapper': {
        fontSize: 18,
        fontWeight: 400,
        color: '#5A5A5A',
      },
      '& .how-cover-image': {
        height: 550,
        borderRadius: 24,
        '@media(max-width: 900px)': {
          height: '100%',
        },
      },
      '& .step-content': {
        maxWidth: 400,
        color: '#5A5A5A',
        fontSize: 16,
        fontWeight: 400,
        letterSpacing: '-0.02em',
      },
      '& .working-steps-container': {
        paddingBottom: 24,
        marginBottom: 8,
        borderBottom: '1px solid #707d9433',

        '& .step-counter': {
          borderRadius: '36px',
          backgroundColor: palette.primary.main,
          color: palette.text.primary,
          fontWeight: 400
        },
        '& .step-title': {
          fontSize: 24,
          fontWeight: 500,
          letterSpacing: '-0.01em',
        },
      },
      '@media(min-width: 900px)': {
        '& .howitworks-wrapper-left': {
          paddingRight: 80,
        },
      }
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .section-header': {
        '& .section-header__title': {
          color: palette.text.primary,
        },
        '& .section-header__subtitle': {
          color: palette.text.primary,
        },
      },
      '& .service-plan-table': {
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 400,
        },
      },

      '& .footer-bar': {
        backgroundColor: palette.background.primary,

        '& .footer-bar-text': {
          color: palette.text.highlight,
        },
      },
      '& .savings-contact-card': {
        padding: '0px 60px !important',
        background: palette.background.footer,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .section-alternate__content': {
        paddingTop: 64,
        paddingBottom: 64
      },
      '& .hero-static-title': {
        fontWeight: 'normal',
        letterSpacing: '-0.04em',
      },
      '& .hero-static-subtitle': {
        color: palette.text.secondary,
      },
      '& .hero-static-bg': {
        backgroundColor: palette.background.footer,
      },
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .planCard': {
        '&:hover': {
          color: palette.text.primary,
          backgroundColor: palette.text.highlight,
          '& .highlight-divider': {
            background: palette.divider,
          },
        },
        '& .customGetStarted': {
          backgroundColor: palette.primary.main,
          color: palette.secondary.main,
          borderColor: palette.secondary.main,
          '&:hover': {
            backgroundColor: palette.secondary.main,
            color: palette.primary.main,
          }
        }
      },
      '& .primary-static-button': {
        backgroundColor: palette.primary.main,
      },
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        background: palette.background.light,
        border: `1px solid ${palette.primary.main}`,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .hero-header-title, & .hero-header-subtitle': {
        textAlign: 'center',
      },
    },
    '& .faqInnerContainer': {
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
      },
    },
    '& .faq-contact-section': {
      '& .contact-card-subtitle': {
        color: palette.text.secondary,
        fontSize: 20,
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.background.footer,
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
        padding: 0,
        marginRight: 8,
      },
      '& .provider-contact-details': {
        fontSize: 14,
        fontWeight: 400,
      },
      '& .provider-contact-link': {
        fontSize: 18,
        fontWeight: 500,
      },
    },

    /* Subscription Success Page */
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
    },

    /* Footer style */
    '& .footer-wrapper': {
      background: palette.text.highlight,
      borderTop: `1px solid ${palette.divider}`,
    },
  },
};
